import React, { useEffect, useState } from "react";
import { CarouselApi } from "../components/ui/carousel";

type UseCarouselApiReturn = {
  mainCarouselApi: CarouselApi;
  setMainCarouselApi: React.Dispatch<CarouselApi>;
  handlePrevious: VoidFunction;
  handleNext: VoidFunction;
  canScrollNext: boolean;
  canScrollPrev: boolean;
  activeIndex: number;
};
function useCarouselApi(): UseCarouselApiReturn {
  const [mainCarouselApi, setMainCarouselApi] = useState<CarouselApi>();
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (mainCarouselApi) {
      const updateScrollState = () => {
        setCanScrollPrev(mainCarouselApi.canScrollPrev());
        setCanScrollNext(mainCarouselApi.canScrollNext());
        setActiveIndex(mainCarouselApi.selectedScrollSnap());
      };

      mainCarouselApi.on("select", updateScrollState);
      mainCarouselApi.on("reInit", updateScrollState);

      updateScrollState();

      return () => {
        mainCarouselApi.off("select", updateScrollState);
        mainCarouselApi.off("reInit", updateScrollState);
      };
    }
  }, [mainCarouselApi]);

  const handlePrevious = () => {
    if (!canScrollPrev) return;
    mainCarouselApi?.scrollPrev();
  };

  const handleNext = () => {
    if (!canScrollNext) return;
    mainCarouselApi?.scrollNext();
  };

  return {
    mainCarouselApi,
    setMainCarouselApi,
    handlePrevious,
    handleNext,
    canScrollNext,
    canScrollPrev,
    activeIndex,
  };
}

export default useCarouselApi;
